import React from "react"
import Img from "gatsby-image"
import style from "../components/fig.module.scss"

function createMarkup(tekst) {
  return { __html: tekst }
}

export default function Fig({
  height,
  image,
  caption,
  stylo,
  imgStylo,
  padding,
  figStylo,
}) {
  return (
    <figure style={figStylo} className={style.wrapper}>
      <Img
        fluid={image}
        fadeIn={false}
        style={{ borderRadius: "5px", ...stylo }}
        imgStyle={imgStylo}
      ></Img>
      <figcaption
        dangerouslySetInnerHTML={createMarkup(caption)}
        style={{ marginTop: "0.5em" }}
      ></figcaption>
    </figure>
  )
}
